export const STORAGE_KEYS = {
  AUTH_TOKEN: 'cleanno_auth_token',
  CURRENT_USER: 'cleanno_current_user',
  LANGUAGE: 'cleanno_language',
  THEME: 'cleanno_theme',
  emailLoginTrustedToken: (userId: string) => `cleanno_email_login_trusted_${userId}`,
} as const;

